import React from 'react';
import { useStyles } from './LogsStyle';
export default function Logs() {
  const data = [
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;type=all-p0;cat=visit0;ord=93627407922222222460;g`,
    },
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;type=all-p0;cat=visit0;ord=93627407922222222460;g`,
    },
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;type=all-p0;cat=visit0;ord=93627407922222222460;g`,
    },
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;type=all-p0;cat=visit0;ord=93627407922222222460;g`,
    },
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;type=all-p0;cat=visit0;ord=93627407922222222460;g`,
    },
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;type=all-p0;cat=visit0;ord=93627407922222222460;g`,
    },
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;type=all-p0;cat=visit0;ord=93627407922222222460;g`,
    },
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;type=all-p0;cat=visit0;ord=93627407922222222460;g`,
    },
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;type=a`,
    },
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;type=all-p0;cat=visit0;ord=`,
    },
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;typ`,
    },
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;type`,
    },
    {
      des: `Kafka/- 17df67d9 iframe height="0" width="0" style="display: none; visibility: hidden;" src="//11382506.fls.doubleclick.net/activityi;src=11382506;type=all-p0;cat=visit0;`,
    },
  ];
  const style = useStyles();
  return (
    <div>
      <div className={style.logsDivButton}>
        <button className={style.logsButton}>Enable Logs integration</button>
      </div>
      <div className={style.logDiv}>
        {data.map((item, i) => {
          return (
            <div className={i === 12 ? style.logDivTxt1 : style.logDivTxt}>
              {item.des}
            </div>
          );
        })}
      </div>
    </div>
  );
}
